import { createStyles, Theme } from '@material-ui/core/styles';

const styles = ({ spacing }: Theme) => createStyles({
  tabsRoot: {
    marginBottom: spacing(6),
  },
});

export default styles;
